import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { StepsComponent } from '@tran-monorepo/frontend/components';
import { StepTile } from '@tran-monorepo/interfaces';
import { ContentSectionComponent } from '../content-section/content-section.component';

@Component({
    selector: 'tran-step-section',
    imports: [TranslatePipe, ContentSectionComponent, StepsComponent],
    templateUrl: './step-section.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StepSectionComponent {
    public readonly backgroundImage = input<string>();
    public readonly eyebrow = input<string>();
    public readonly titleKey = input<string>();
    public readonly boldTitle = input<string>();
    public readonly steps = input<StepTile[]>([]);
}
